export const DWB21_Green = '#8D9F6B';
export const DWB21_Blue = '#E4F0E6';
export const DWB21_Purple = '#BDA2D1';
export const DWB21_Teal = '#75AAB3';
export const DWB21_Cream = '#F3EDDD';
export const DWB21_Black = '#000000';
export const DWB21_Peach = '#EAC6B8';
